import { render } from "./Event.vue?vue&type=template&id=de11b9a8"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"

import "./Event.vue?vue&type=style&index=0&id=de11b9a8&lang=scss"
script.render = render

export default script